import { shibarium } from "viem/chains"


export const platformFee = 250

export type MarketplaceSettings = {
  platformFee: number;
  headlineText: string;
}

export type MarketplaceSettingsByChainType = {
  [chainId: number]: MarketplaceSettings;
}

export const marketplaceSettings: MarketplaceSettingsByChainType = {
  [shibarium.id]: {
    platformFee: platformFee,
    headlineText: "",
  }
}